import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronRight, Shield, Leaf, Building2 } from 'lucide-react';
import { FAQAccordion } from '../../components/FAQAccordion';
import { CTAStrip } from '../../components/CTAStrip';
import { InlineCostCalculator } from '../../components/InlineCostCalculator';
const faqs = [{
  question: 'How quickly can you clear a void property?',
  answer: 'We can typically clear a void property within 24–48 hours of instruction. Same-day service is available for urgent cases.'
}, {
  question: 'Do you work with multiple estate agents?',
  answer: 'Yes. We work with independent agents, national chains, and property management companies across London.'
}, {
  question: 'Can we set up a contract for regular clearances?',
  answer: 'Absolutely. We offer preferential contract rates for estate agents with regular clearance needs.'
}, {
  question: 'Do you provide documentation for compliance?',
  answer: 'Yes. Full waste transfer notes and duty of care documentation provided for every clearance.'
}, {
  question: 'Can you handle sensitive or hoarded properties?',
  answer: 'Yes. Our team is trained to handle sensitive situations with discretion and professionalism.'
}];
export function EstateAgentPage() {
  return <div className="pt-16 lg:pt-20" data-id="element-807">
      <section className="relative h-72 md:h-96 overflow-hidden" data-id="element-808">
        <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&auto=format&fit=crop" alt="Estate agent clearance" className="w-full h-full object-cover" data-id="element-809" />
        <div className="absolute inset-0 hero-overlay" data-id="element-810" />
        <div className="absolute inset-0 flex items-center" data-id="element-811">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-812">
            <nav className="flex items-center gap-2 text-green-200 text-sm mb-4" data-id="element-813">
              <Link to="/" className="hover:text-white" data-id="element-814">
                Home
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-815" />
              <Link to="/services" className="hover:text-white" data-id="element-816">
                Services
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-817" />
              <span className="text-white" data-id="element-818">Estate Agent Clearance</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-extrabold text-white" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-819">
              Estate Agent Clearance Service London
            </h1>
            <p className="text-green-100 mt-3 text-lg" data-id="element-820">
              Fast void property clearances for estate agents & landlords. From
              £120.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-821">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-822">
          <div data-id="element-823">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-824">
              What's Included
            </h2>
            <ul className="space-y-3" data-id="element-825">
              {['Void property clearances', 'End-of-tenancy clearances', 'Probate & estate clearances', 'Hoarded property clearances', 'Garden clearances included', 'Rapid 24-hour turnaround', 'Full waste documentation', 'Contract rates available'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-826">
                  <CheckCircle className="w-5 h-5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-827" />
                  <span className="text-gray-700" data-id="element-828">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-829">
            <div className="bg-green-50 rounded-2xl p-6" data-id="element-830">
              <Building2 className="w-10 h-10 mb-3" style={{
              color: '#1B8F4B'
            }} data-id="element-831" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-832">
                Partner With Us
              </h3>
              <p className="text-gray-600 text-sm mb-4" data-id="element-833">
                Join the estate agents and property managers who trust Universal
                Global Logistics for their clearance needs.
              </p>
              <ul className="space-y-2" data-id="element-834">
                {['Priority booking for partners', 'Dedicated account manager', 'Volume discount pricing', 'Same-day emergency service'].map(b => <li key={b} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-835">
                    <CheckCircle className="w-4 h-4" style={{
                  color: '#1B8F4B'
                }} data-id="element-836" />{' '}
                    {b}
                  </li>)}
              </ul>
              <Link to="/contracts" className="inline-block mt-4 px-6 py-3 rounded-xl font-bold text-white text-sm transition-colors hover:opacity-90" style={{
              backgroundColor: '#1B8F4B',
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-837">
                View Partnership Options
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-838">
        <div className="max-w-3xl mx-auto text-center" data-id="element-839">
          <div className="rounded-2xl border-2 border-[#1B8F4B] p-8 mb-6" data-id="element-840">
            <p className="text-4xl font-extrabold mb-2" style={{
            color: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-841">
              From £120
            </p>
            <p className="text-gray-500 mb-6" data-id="element-842">
              Guide price for a small void property clearance. Contract rates
              available.
            </p>
            <Link to="/contact" className="inline-block px-8 py-4 rounded-xl font-bold text-white transition-colors hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-843">
              Request a Quote
            </Link>
          </div>
          <div className="flex justify-center gap-6" data-id="element-844">
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-845">
              <Shield className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-846" />{' '}
              Licensed & Fully Insured
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-847">
              <Leaf className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-848" />{' '}
              Eco-Friendly Disposal
            </div>
          </div>
        </div>
      </section>

      <InlineCostCalculator defaultService="house-clearance" serviceName="Estate Agent Clearance" data-id="element-849" />

      <section className="py-16 px-4 bg-white" data-id="element-850">
        <div className="max-w-3xl mx-auto" data-id="element-851">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-852">
            FAQs
          </h2>
          <FAQAccordion items={faqs} data-id="element-853" />
        </div>
      </section>
      <CTAStrip heading="Need a Reliable Clearance Partner?" subheading="Get in touch today. We reply within 30 minutes." data-id="element-854" />
    </div>;
}